export function CmsDashboard() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-text">CMS Dashboard</h1>
      <p className="text-text-muted">Website content management overview will be displayed here.</p>
    </div>
  )
}
